export type TitleKeyTypes =
  | 'otpVerificationFailedTitle'
  | 'sessionExpiredTitle'
  | 'browserNotSupported'
  | 'browserNotSupportedProceed'
  | 'sessionExpiredDescription'
  | 'transactionExpiredTitle'
  | 'transactionExpiredDescription'
  | 'alreadyUsedTitle'
  | 'alreadyUsedDescription'
  | 'transactionAlreadyEndedTitle'
  | 'transactionCancelledTitle'
  | 'pageNotFound'
  | 'ageVerificationFailedTitle'
  | 'title'

export type DescriptionKeyTypes =
  | 'transactionExpiredDescription'
  | 'transactionCancelledDescription'
  | 'sessionExpiredDescription'
  | 'alreadyUsedDescription'
  | 'transactionAlreadyEndedDescription'
  | 'ageVerificationFailedDescription'

export interface ErrorPageTypeObject {
  type: string
  titleKey: TitleKeyTypes
  iconPosition: 'top' | 'middle' | 'bottom' // in the future we will introduce different positioning mobile vs desktop
  iconPositionMobile?: 'top' | 'middle' | 'bottom' | undefined
  descriptionKey?: DescriptionKeyTypes | undefined
}

export const errorMap: Record<string, ErrorPageTypeObject> = {
  'error-otp-verification-failed': {
    type: 'otp-verification-failed',
    titleKey: 'otpVerificationFailedTitle',
    iconPosition: 'top',
    descriptionKey: undefined,
  },
  'error-session-expired': {
    type: 'session-expired',
    titleKey: 'sessionExpiredTitle',
    iconPosition: 'middle',
    descriptionKey: 'sessionExpiredDescription',
  },
  'error-transaction-expired': {
    type: 'transaction-expired',
    titleKey: 'transactionExpiredTitle',
    iconPosition: 'middle',
    descriptionKey: 'transactionExpiredDescription',
  },
  'error-already-used': {
    type: 'already-used',
    titleKey: 'alreadyUsedTitle',
    iconPosition: 'middle',
    descriptionKey: undefined,
  },
  'browser-not-supported': {
    type: 'browser-not-supported',
    titleKey: 'browserNotSupported',
    iconPosition: 'middle',
    descriptionKey: undefined,
  },
  'error-transaction-already-ended': {
    type: 'transaction-already-ended',
    titleKey: 'transactionAlreadyEndedTitle',
    iconPosition: 'middle',
    descriptionKey: 'transactionAlreadyEndedDescription',
  },
  'error-transaction-cancelled': {
    type: 'transaction-cancelled',
    titleKey: 'transactionCancelledTitle',
    iconPosition: 'middle',
    descriptionKey: 'transactionCancelledDescription',
  },
  'error-age-verification-failed': {
    type: 'error',
    titleKey: 'ageVerificationFailedTitle',
    iconPosition: 'middle',
    descriptionKey: 'ageVerificationFailedDescription',
  },
  error: {
    type: 'default',
    titleKey: 'title',
    iconPosition: 'middle',
    descriptionKey: undefined,
  },
}
